import { Component } from '@angular/core';

@Component({
  selector: 'credit-report-landing',
  templateUrl: './credit-report-landing.component.html'
})
export class CreditReportLandingComponent {}
